import { default as setCookieLib } from './doccookies'

// initialize libraries in the window
const setVendors = () => {
  window.setCookieLib = setCookieLib
}

export default setVendors()